import React, { useState } from "react";
import { CsplTable as Table } from "../../../components";
import VestingRowGroup from "../../../components/VestingRowGroup/VestingRowGroup";

const columns = [
  {
    label: "",
    className: "column-vesting-icon",
    columnName: "icon",
  },
  {
    label: "Employee Names",
    className: "column-vesting-employeeName",
    columnName: "employeeName",
  },
  {
    label: "Employee ID",
    className: "column-vesting-employeeId",
    columnName: "employeeId",
  },
  {
    label: "Social Security Number",
    className: "column-vesting-socialSecurityNumber",
    columnName: "socialSecurityNumber",
  },
];

const VestingPlan = ({
  data = [],
  isLoading,
  handleSort,
  totalRecords,
  scrollEndCallBack,
}) => {
  const [sortingData, setSortingData] = useState({});

  const onSortClick = (item, index, orderBy) => {
    const details = {
      column: item.columnName,
      columnIndex: index,
      orderBy,
    };
    setSortingData(details);
    handleSort(details);
  };

  const scrollCallBack = (_, pageDetails) => {
    scrollEndCallBack(pageDetails, "generic");
  };

  return (
    <div className="eligibiliy-slider-table overflow-hidden">
      <div className="history-eligibility-scroll">
        <div />
        <Table isLoading={isLoading}>
          <Table.Thead>
            <Table.Tr>
              {columns.map((item, index) => {
                const orderBy =
                  sortingData.columnIndex === index ? sortingData.orderBy : "";
                return (
                  <Table.Th
                    key={index}
                    className={item.className}
                    isSortable={item.isSortable}
                    orderBy={orderBy}
                    onClick={(sortOrder) => onSortClick(item, index, sortOrder)}
                  >
                    {item.label}
                  </Table.Th>
                );
              })}
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody
            scrollEndCallBack={scrollCallBack}
            totalRecords={totalRecords}
          >
            {data.map((employee, index) => {
              return <VestingRowGroup index={index} employee={employee} />;
            })}
          </Table.Tbody>
        </Table>
      </div>
    </div>
  );
};

export default VestingPlan;
